import { toast } from '@approvalmax/ui/src/components';
import { useSetAtom } from 'jotai';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useCallback } from 'react';
import { useUpdateSyncQBooksBudgets } from 'shared/data/webApp/v2';

import { messages } from '../messages';
import { syncQBooksBudgetsPageState } from '../states';

const integrationName = selectors.integration.getIntegrationTypeName(domain.IntegrationType.QBooks);

export const useToggleQBooksBudgetsSync = (company: selectors.types.ExpandedCompany) => {
    const { mutate: updateSyncQBooksBudgets, ...rest } = useUpdateSyncQBooksBudgets();

    const setSyncQBooksBudgetsState = useSetAtom(syncQBooksBudgetsPageState);

    const toggleSync = useCallback(
        (isEnabled: boolean) => {
            updateSyncQBooksBudgets(
                {
                    params: {
                        path: {
                            companyId: company.id,
                        },
                    },
                    body: {
                        isEnabled,
                    },
                },
                {
                    onSuccess: () => {
                        toast.success(
                            isEnabled
                                ? messages.syncEnabled({ integrationName })
                                : messages.syncDisabled({ integrationName })
                        );

                        if (isEnabled) {
                            setSyncQBooksBudgetsState(true);
                        }
                    },
                }
            );
        },
        [company.id, updateSyncQBooksBudgets, setSyncQBooksBudgetsState]
    );

    return {
        toggleSync,
        ...rest,
    };
};
